import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
});

// Add auth token to admin requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token && config.url.includes('/admin')) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Public APIs
export const getEvents = (category) => {
  const params = category && category !== 'all' ? { category } : {};
  return api.get('/events', { params });
};

export const getEvent = (id) => api.get(`/events/${id}`);

export const getCategories = () => api.get('/categories');

export const getLatestVideo = () => api.get('/latest-video');

export const registerAttendee = (data) => api.post('/register', data);

export const trackVisit = (data) => api.post('/track', data).catch(() => {});

export const getAnalytics = (days = 30) => api.get(`/admin/analytics?days=${days}`);

// Checkout APIs
export const createCheckoutSession = (data) => {
  return axios.post(`${BACKEND_URL}/api/checkout/create-session`, data);
};

export const getCheckoutStatus = (sessionId) => {
  return axios.get(`${BACKEND_URL}/api/checkout/status/${sessionId}`);
};

// Admin APIs
export const adminLogin = (email, password) => {
  return api.post('/admin/login', { email, password });
};

export const verifyAdmin = () => api.get('/admin/verify');

export const getAdminStats = () => api.get('/admin/stats');

export const getAdminEvents = () => api.get('/admin/events');

export const createEvent = (data) => api.post('/admin/events', data);

export const updateEvent = (id, data) => api.put(`/admin/events/${id}`, data);

export const deleteEvent = (id) => api.delete(`/admin/events/${id}`);

export const getEventAttendees = (eventId) => api.get(`/admin/events/${eventId}/attendees`);

export const exportAttendeesCSV = (eventId) => {
  return api.get(`/admin/events/${eventId}/attendees/export`, { responseType: 'blob' });
};

export default api;
